import { render, staticRenderFns } from "./vgpRollItems.vue?vue&type=template&id=20693aae&"
import script from "./vgpRollItems.vue?vue&type=script&lang=js&"
export * from "./vgpRollItems.vue?vue&type=script&lang=js&"
import style0 from "./groups.less?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./groups.less?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./groups.less?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("20693aae")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20693aae')) {
      api.createRecord('20693aae', component.options)
    } else {
      api.reload('20693aae', component.options)
    }
    module.hot.accept("./vgpRollItems.vue?vue&type=template&id=20693aae&", function () {
      api.rerender('20693aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/rollItems/vgpRollItems.vue"
export default component.exports